// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import {
    Avatar,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";



// main function
export default function MultiBadContractAvatar({ rowContractData }) {


    return (

        <Box>
            {
                ((rowContractData.comboStatus === 'm') && (rowContractData.inputMissingRollup > 0 ))
                &&
                <div>
                    <Tooltip
                        enterDelay={1000}
                        title="MultiBadContractAvatar"
                    >
                    <Avatar sx={{ml: 0,height: 20, width: 20, fontSize: 14, bgcolor: '#d50000'}}>m
                    </Avatar>
                        </Tooltip>
                </div>}
        </Box>

    )

}
